var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3 grey lighten-4"},[_c('v-card',{staticClass:"card--flex-toolbar"},[_c('v-card-text',{staticClass:"pa-0"},[_c('TransactionList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }